<template>
  <b-modal
    id="modal-tarugo-appointment"
    v-model="isVisible"
    title="Apontamento Parcial — Dados do Tarugo"
    hide-footer
    centered
    size="lg"
    no-close-on-backdrop
    no-enforce-focus
    content-class="operator-tarugo-modal-content"
    header-class="border-bottom-0 pb-0"
    @hidden="onModalHidden"
  >
    <div class="tarugo-modal-body p-1 font-raleway">
      <!-- OP Header Badge -->
      <div class="op-header-info p-2 mb-3 rounded border bg-light d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center">
          <feather-icon icon="LayersIcon" size="20" class="text-copper mr-1" />
          <div>
            <div class="small text-muted font-weight-bold">Ordem de Produção</div>
            <div class="h5 font-weight-bold text-dark mb-0">#{{ orderCode }}</div>
          </div>
        </div>
        <span class="badge badge-light-warning">Apontamento de Prensa</span>
      </div>

      <!-- 11 Fields Form Grid -->
      <b-row class="form-grid">
        <!-- 1. Liga -->
        <b-col cols="12" sm="6" md="4" class="mb-2">
          <label class="input-label">Liga <span class="text-danger">*</span></label>
          <select v-model="form.alloy" class="operator-input w-100 cursor-pointer">
            <option value="" disabled>Selecione a Liga</option>
            <option v-for="opt in computedAlloyOptions" :key="opt" :value="opt">{{ opt }}</option>
          </select>
        </b-col>

        <!-- 2. Origem -->
        <b-col cols="12" sm="6" md="4" class="mb-2">
          <label class="input-label">Origem <span class="text-danger">*</span></label>
          <select v-model="form.origin" class="operator-input w-100 cursor-pointer">
            <option value="" disabled>Selecione a Origem</option>
            <option value="Alumasa">Alumasa</option>
            <option value="Importado">Importado</option>
            <option value="Nacional">Nacional</option>
            <option value="Interno">Reciclado / Interno</option>
          </select>
        </b-col>

        <!-- 3. Fusão / Corrida -->
        <b-col cols="12" sm="6" md="4" class="mb-2">
          <label class="input-label">Fusão / Corrida <span class="text-danger">*</span></label>
          <input
            type="text"
            v-model="form.heatNumber"
            class="operator-input w-100"
            placeholder="Ex: FUS-9912"
          />
        </b-col>

        <!-- 4. Tamanho Tarugo (mm) -->
        <b-col cols="12" sm="6" md="4" class="mb-2">
          <label class="input-label">Tamanho tarugo (mm) <span class="text-danger">*</span></label>
          <input
            type="number"
            step="0.1"
            v-model.number="form.sizeMm"
            class="operator-input w-100"
            placeholder="Ex: 500.0"
          />
        </b-col>

        <!-- 5. Quantidade (Tarugos) -->
        <b-col cols="12" sm="6" md="4" class="mb-2">
          <label class="input-label">Qtd. Tarugos <span class="text-danger">*</span></label>
          <input
            type="number"
            step="1"
            v-model.number="form.quantity"
            class="operator-input w-100"
            placeholder="Ex: 10"
          />
        </b-col>

        <!-- 6. Puxada (m) -->
        <b-col cols="12" sm="6" md="4" class="mb-2">
          <label class="input-label">Comprimento Puxada (m) <span class="text-danger">*</span></label>
          <input
            type="number"
            step="0.1"
            v-model.number="form.pullLengthM"
            class="operator-input w-100"
            placeholder="Ex: 6.0"
          />
        </b-col>

        <!-- 7. Temperatura (°C) -->
        <b-col cols="12" sm="6" md="4" class="mb-2">
          <label class="input-label">Temp. Tarugo (°C) <span class="text-danger">*</span></label>
          <input
            type="number"
            step="1"
            v-model.number="form.temperature"
            class="operator-input w-100"
            placeholder="Ex: 480"
          />
        </b-col>

        <!-- 8. Emergente (°C) -->
        <b-col cols="12" sm="6" md="4" class="mb-2">
          <label class="input-label">Temp. Emergente (°C) <span class="text-danger">*</span></label>
          <input
            type="number"
            step="1"
            v-model.number="form.emergentTemperature"
            class="operator-input w-100"
            placeholder="Ex: 510"
          />
        </b-col>

        <!-- 9. Vel. Extrusão (m/min) -->
        <b-col cols="12" sm="6" md="4" class="mb-2">
          <label class="input-label">Vel. Extrusão (m/min) <span class="text-danger">*</span></label>
          <input
            type="number"
            step="0.1"
            v-model.number="form.extrusionSpeed"
            class="operator-input w-100"
            placeholder="Ex: 30.0"
          />
        </b-col>

        <!-- 10. Peso do Perfil (kg/m) -->
        <b-col cols="12" sm="6" md="4" class="mb-2">
          <label class="input-label">Peso Perfil (kg/m) <span class="text-danger">*</span></label>
          <input
            type="number"
            step="0.001"
            v-model.number="form.profileWeight"
            class="operator-input w-100"
            placeholder="Ex: 2.500"
          />
        </b-col>
      </b-row>

      <!-- Action Buttons -->
      <div class="d-flex align-items-center justify-content-end gap-2 mt-3 pt-2 border-top">
        <button class="btn-operator-secondary px-3 mr-1" @click="isVisible = false" :disabled="submitting">
          Cancelar
        </button>
        <button
          class="btn-operator-confirm px-4"
          :disabled="!isFormValid || submitting"
          @click="submitTarugoAppointment"
        >
          <b-spinner v-if="submitting" small class="mr-50" />
          <feather-icon v-else icon="CheckIcon" size="18" class="mr-50" />
          <span>Salvar Apontamento</span>
        </button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { BModal, BRow, BCol, BSpinner } from 'bootstrap-vue';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import { createTarugoAppointment, getExtrusionAlloys } from '../extrusionApi';

export default {
  name: 'TarugoAppointmentModal',
  components: {
    BModal,
    BRow,
    BCol,
    BSpinner,
    ToastificationContent
  },
  props: {
    orderCode: {
      type: String,
      required: true
    },
    presetData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      isVisible: false,
      submitting: false,
      alloyOptions: [],
      form: {
        alloy: '6063',
        heatNumber: '',
        origin: '',
        sizeMm: null,
        quantity: null,
        pullLengthM: null,
        temperature: null,
        emergentTemperature: null,
        extrusionSpeed: null,
        profileWeight: null
      }
    };
  },
  computed: {
    computedAlloyOptions() {
      const base = (this.presetData?.availableAlloys && Array.isArray(this.presetData.availableAlloys) && this.presetData.availableAlloys.length > 0)
        ? this.presetData.availableAlloys
        : (this.alloyOptions || []);
      const list = [...base];

      const ordAlloy = this.presetData?.alloy || this.presetData?.productParameters?.liga;
      if (ordAlloy && ordAlloy !== '-' && !list.includes(ordAlloy)) {
        list.unshift(ordAlloy);
      }
      if (this.form.alloy && !list.includes(this.form.alloy)) {
        list.unshift(this.form.alloy);
      }
      const unique = Array.from(new Set(list.filter(x => x && x !== '-')));
      return unique.length > 0 ? unique : (this.form.alloy ? [this.form.alloy] : ['6063']);
    },
    siteId() {
      const cookieSite = this.$cookies?.get('userInfo')?.currentSite;
      if (cookieSite) {
        if (typeof cookieSite === 'object' && cookieSite.id) return cookieSite.id;
        if (typeof cookieSite === 'number') return cookieSite;
        if (!isNaN(cookieSite)) return parseInt(cookieSite, 10);
      }
      const storedSite = localStorage.getItem('siteId') || localStorage.getItem('currentSite');
      if (storedSite) {
        try {
          const parsed = JSON.parse(storedSite);
          if (parsed && parsed.id) return parsed.id;
          if (typeof parsed === 'number') return parsed;
        } catch (e) {
          if (!isNaN(storedSite)) return parseInt(storedSite, 10);
        }
      }
      return 1;
    },
    isFormValid() {
      return (
        this.orderCode &&
        this.form.alloy &&
        this.form.heatNumber &&
        this.form.origin &&
        this.form.sizeMm > 0 &&
        this.form.quantity > 0 &&
        this.form.pullLengthM > 0 &&
        this.form.temperature > 0 &&
        this.form.emergentTemperature > 0 &&
        this.form.extrusionSpeed > 0 &&
        this.form.profileWeight > 0
      );
    }
  },
  watch: {
    presetData: {
      immediate: true,
      async handler(data) {
        if (data && typeof data === 'object') {
          if ((!data.availableAlloys || data.availableAlloys.length === 0) && (!this.alloyOptions || this.alloyOptions.length === 0)) {
            try {
              const res = await getExtrusionAlloys();
              const alloys = res.data?.data || res.data || [];
              if (Array.isArray(alloys) && alloys.length > 0) {
                this.alloyOptions = alloys;
              }
            } catch (e) {
              console.error('Erro ao buscar ligas:', e);
            }
          }
          if (data.alloy) this.form.alloy = data.alloy;
          if (data.extrusionSpeedTarget) this.form.extrusionSpeed = data.extrusionSpeedTarget;
          const last = data.lastTarugoDetails || data.latestTarugoAppointment;
          if (last) {
            if (last.alloy) this.form.alloy = last.alloy;
            if (last.sizeMm && Number(last.sizeMm) > 50) this.form.sizeMm = last.sizeMm;
            if (last.pullLengthM) this.form.pullLengthM = last.pullLengthM;
            if (last.temperature) this.form.temperature = last.temperature;
            if (last.emergentTemperature) this.form.emergentTemperature = last.emergentTemperature;
            if (last.extrusionSpeedMMin || last.extrusionSpeed) this.form.extrusionSpeed = last.extrusionSpeedMMin || last.extrusionSpeed;
            if (last.profileWeightKgM || last.profileWeight) this.form.profileWeight = last.profileWeightKgM || last.profileWeight;
            // Campos fora do bloco azul permanecem em branco
            this.form.heatNumber = '';
            this.form.origin = '';
            this.form.quantity = null;
          } else {
            this.form.heatNumber = '';
            this.form.origin = '';
            this.form.sizeMm = null;
            this.form.quantity = null;
            this.form.pullLengthM = null;
            this.form.temperature = null;
            this.form.emergentTemperature = null;
            this.form.extrusionSpeed = null;
            this.form.profileWeight = null;
          }
        }
      }
    }
  },
  methods: {
    show() {
      this.isVisible = true;
    },
    hide() {
      this.isVisible = false;
    },
    async submitTarugoAppointment() {
      if (!this.isFormValid) return;

      this.submitting = true;
      const payload = {
        operationId: this.presetData?.operationId || 0,
        resourceId: this.presetData?.resourceId || 0,
        liga: this.form.alloy,
        fusao: this.form.heatNumber,
        origem: this.form.origin,
        tamanhoMm: Number(this.form.sizeMm),
        quantidade: Number(this.form.quantity),
        puxadaM: Number(this.form.pullLengthM),
        temperatura: Number(this.form.temperature),
        temperaturaEmergente: Number(this.form.emergentTemperature)
      };

      try {
        await createTarugoAppointment(payload, this.siteId);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Sucesso',
            icon: 'CheckIcon',
            text: 'Apontamento de tarugo registrado com sucesso!',
            variant: 'success'
          }
        });
        this.$emit('submitted', payload);
        this.isVisible = false;
      } catch (error) {
        console.error('Erro ao salvar apontamento do tarugo:', error);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Erro',
            icon: 'AlertTriangleIcon',
            text: 'Falha ao salvar o apontamento de tarugo no backend.',
            variant: 'danger'
          }
        });
      } finally {
        this.submitting = false;
      }
    },
    onModalHidden() {
      this.submitting = false;
    }
  }
};
</script>

<style lang="scss">
.operator-tarugo-modal-content {
  border-radius: 12px !important;
  border: 1px solid #cfc4be !important;
  font-family: "Raleway", sans-serif !important;

  .text-copper {
    color: #974900 !important;
  }

  .input-label {
    font-size: 12px;
    font-weight: 700;
    color: #4c4541;
    margin-bottom: 4px;
    display: block;
  }

  .operator-input {
    height: 42px;
    padding: 0 12px;
    background: #fafafa;
    border: 1px solid #cfc4be;
    border-radius: 6px;
    font-size: 14px;
    color: #4c4541;
    transition: border-color 0.2s;

    &:focus {
      border-color: #974900;
      outline: none;
      background: #fff;
    }
  }

  .btn-operator-secondary {
    height: 42px;
    background: #fafafa;
    border: 1px solid #cfc4be;
    border-radius: 6px;
    color: #4c4541;
    font-weight: 600;
    font-size: 14px;
    cursor: pointer;

    &:hover:not(:disabled) {
      background: #eee;
    }
  }

  .btn-operator-confirm {
    height: 42px;
    background: #974900;
    border: 1px solid #974900;
    border-radius: 6px;
    color: #fff;
    font-weight: 700;
    font-size: 14px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: background 0.2s;

    &:hover:not(:disabled) {
      background: #7a3b00;
      border-color: #7a3b00;
    }

    &:disabled {
      opacity: 0.55;
      cursor: not-allowed;
    }
  }
}
</style>
